import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-text-field',
  templateUrl: './s-polaris-text-field.component.html',
  styleUrls: ['./s-polaris-text-field.component.scss'],
  standalone: false,
})
export class PolarisTextFieldComponent {
  @Input() label = '';
  @Input() value?: string;
  @Input() type: 'text' | 'number' = 'text';
  /** Renders a taller box for multi-line text (e.g. a gift note message). */
  @Input() multiline = false;
}
